var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"10.88","height":"2.77","transform":"matrix(-0.706914 -0.7073 0.706914 -0.7073 14.042 10.3286)","fill":"#E3543B","key":0}),React.createElement("rect",{"width":"10.88","height":"2.77","transform":"matrix(0.706914 -0.7073 0.706914 0.7073 0.652832 8.3667)","fill":"#E3543B","key":1})]);
}

ChevronInline.defaultProps = {"width":"16","height":"11","viewBox":"0 0 16 11","fill":"none","className":"icon"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
